import React from 'react';

const STATUS_CONFIG: Record<string, { label: string; bg: string; color: string }> = {
  pending:           { label: 'Pending',           bg: '#F2F4F7', color: '#475467' },
  rail_chosen:       { label: 'Rail Chosen',        bg: '#EEF2FF', color: '#1D5EFF' },
  payment_detected:  { label: 'Payment Detected',   bg: '#ECFDF3', color: '#0B7A5A' },
  settled:           { label: 'Settled',            bg: '#ECFDF3', color: '#0B7A5A' },
  failed:            { label: 'Failed',             bg: '#FEF3F2', color: '#B42318' },
  expired:           { label: 'Expired',            bg: '#FEF3F2', color: '#B42318' },
  // Promo code statuses (active | disabled | expired); 'expired' shares the row above.
  active:            { label: 'Active',             bg: '#ECFDF3', color: '#0B7A5A' },
  disabled:          { label: 'Disabled',           bg: '#F2F4F7', color: '#475467' },
};

interface StatusChipProps {
  status: string;
  className?: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({ status, className = '' }) => {
  const cfg = STATUS_CONFIG[status] ?? { label: status, bg: '#F2F4F7', color: '#475467' };
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-md text-[11px] font-medium tracking-wide ${className}`}
      style={{ background: cfg.bg, color: cfg.color }}
    >
      {cfg.label}
    </span>
  );
};

export default StatusChip;
